import React from 'react';
import PropTypes from 'prop-types';
import { EditorView } from 'prosemirror-view';
import { useIntl } from 'react-intl';

import { messages } from '../../../../../../_shared/i18n/messages';

import { ToolbarButton } from '../../../Toolbar';
import { toggleTooltip } from '../commands';

const propTypes = {

	/**
	 * The id of the DOM element where the editor will be injected.
	 */
	editorDomId: PropTypes.string.isRequired,

	/**
	 * The prosemirror editor view object.
	 */
	editorView: PropTypes.instanceOf(EditorView).isRequired,

	/**
	 * The provided toolbar props to adhere to accessibility (a11y)
	 * guidelines for button toolbars.
	 *
	 * See here: https://www.w3.org/WAI/ARIA/apg/patterns/toolbar
	 */
	a11yToolbarProps: PropTypes.shape({

		/**
		 * The tab index value for the button. Only the button with
		 * current focus should have tab index value of 0. All others
		 * should have value of -1.
		 */
		tabIndex: PropTypes.oneOf(['0', '-1']).isRequired,

		/**
		 * Callback function to handle keypress events on the button.
		 */
		onKeyDown: PropTypes.func.isRequired,

	}),

};

const LinkButton = (props) => {

	const {
		editorDomId,
		editorView,
		a11yToolbarProps = {},
	} = props;

	const intl = useIntl();

	// Only allow linking if this is a TextSelection that
	// spans at least one text node
	const { selection } = editorView.state;
	const disabled = selection.from === selection.to || Boolean(selection.node);

	const handleOnToggle = () => {

		toggleTooltip(editorView.state, editorView.dispatch);

	};

	return (
		<ToolbarButton
			id={`${editorDomId}-toolbar-btn-link`}
			disabled={disabled}
			icon="fas fa-link"
			title={intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_LINK_BUTTON_TITLE)}
			onClick={handleOnToggle}
			{...a11yToolbarProps} />
	);

};

LinkButton.propTypes = propTypes;

export default LinkButton;
